import React from 'react';
import { Card, Row, Col, Badge, Alert } from 'react-bootstrap';
import { FaEye, FaCheckCircle, FaInfoCircle } from 'react-icons/fa';
import Spinner from '../Spinner';
import { safeRenderValue } from './utils/logsUtils';

const ExecutionResultCard = ({
  executionStatus,
  parsedExecutionSummary,
  parsedAgentOutput,
  executionDetails,
  loadingExecutionDetails,
  restoredFromLogs
}) => {
  if (!executionStatus || (executionStatus.status !== 'SUCCEEDED' && !restoredFromLogs)) {
    return null;
  }

  return (
    <Card className="result-card mb-4">
      <Card.Header>
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="section-heading">
            Execution Result
          </h2>
          {loadingExecutionDetails && (
            <div className="text-muted">
              <Spinner size="sm" className="me-2" />
              Loading results...
            </div>
          )}
        </div>
      </Card.Header>
      <Card.Body>
        {(parsedExecutionSummary || parsedAgentOutput) && (
          <div className="parsed-output-section mb-4">
            <h5 className="mb-3">
              <FaEye className="me-2 text-primary" />
              Execution Output {restoredFromLogs ? '(from Execution History)' : '(from Live Logs)'}
            </h5>
            
            {parsedAgentOutput && (
              <div className="mb-4">
                <div className="d-flex align-items-center mb-3">
                  <FaCheckCircle className="me-2 text-success" />
                  <span className="fw-bold text-success">Agent Output:</span>
                </div>
                <div className="info-field-value">
                  <div className="bg-light p-3 rounded border border-success">
                    <pre className="mb-0" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                      {safeRenderValue(parsedAgentOutput)}
                    </pre>
                  </div>
                </div>
              </div>
            )}

            {parsedExecutionSummary && (
              <div className="mb-4">
                <div className="d-flex align-items-center mb-3">
                  <FaInfoCircle className="me-2 text-info" />
                  <span className="fw-bold text-info">Execution Summary:</span>
                </div>
                <div className="info-field-value">
                  <div className="bg-light p-3 rounded border border-info">
                    <pre className="mb-0" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                      {safeRenderValue(parsedExecutionSummary)}
                    </pre>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        
        {executionDetails && (
          <div className="key-fields-section mb-4">
            <h5 className="mb-3">
              <FaEye className="me-2 text-primary" />
              Execution Summary
            </h5>
            
            <div className="mb-4">
              <div className="d-flex align-items-center mb-3">
                <FaCheckCircle className="me-2 text-success" />
                <h6 className="mb-0 text-success">Status</h6>
              </div>
              <div className="info-field-value">
                <div className="bg-light p-3 rounded border border-success">
                  <div className="mb-2">
                    <strong>Status:</strong> <Badge bg="success">{executionDetails.status}</Badge>
                  </div>
                  <div className="mb-0">
                    <strong>Message:</strong> {executionDetails.message}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default ExecutionResultCard;
